import type { ModalProps } from "antd";

export const GALLERY_MODAL_GUTTER = {
  X: 70, // pixels
  Y: 80, // pixels
};

export const GALLERY_MODAL_ZOOM = {
  MIN: 1,
  MAX: 5,
  INITIAL: 1,
  INCREMENT: 0.5,
};

export const GALLERY_MODAL_STYLES: ModalProps["styles"] = {
  mask: { background: "rgba(0,0,0,0.9)" },
};

export const GALLERY_MODAL_CSS_VARIABLES = [
  `--gallery-modal-gutter-x: ${GALLERY_MODAL_GUTTER.X}px;`,
  `--gallery-modal-gutter-y: ${GALLERY_MODAL_GUTTER.Y}px;`,
].join(" ");
